import WingHero from "../components/WingHero";
import WingPrograms from "../components/WingPrograms";
import WingPathwayNav from "../components/WingPathwayNav";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { wingDetails } from "@/mocks/programsData";

const wingData = wingDetails.find((w) => w.wing === "Innovation Wing")!;

export default function InnovationWingPage() {
  return (
    <main className="min-h-screen">
      <WingHero
        badge="Innovation Wing"
        title="Innovation Wing"
        subtitle={wingData.tagline}
        description={wingData.description}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      {/* What Is Section */}
      <section className="bg-tie-grey-light py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-10">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                  <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                    / What This Wing Does
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                  From Factory Floor to Scaled Innovation
                </h2>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <div className="space-y-4 md:space-y-5">
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  The Innovation Wing is TIE's factory-facing engine. It runs the full innovation lifecycle
                  — from ideation circles on the shop floor to practically tested models that can be scaled
                  across factory groups. Every programme in this wing is designed to create measurable,
                  evidence-based change inside factories.
                </p>
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  Whether through PIIC's structured circle methodology, PTIM's test-before-scale validation,
                  tiered training certifications, or on-demand expert consultancy — this wing ensures that
                  innovation is not discussed, but installed, measured, and owned by factory teams themselves.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="mt-8 md:mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { label: "Factories Engaged", value: "80+" },
                  { label: "Projects Deployed", value: "250+" },
                  { label: "Experts Connected", value: "150+" },
                  { label: "Training Hours", value: "256+" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-4 md:p-5 rounded-xl bg-white border border-tie-grey-dark">
                    <p className="font-serif text-2xl md:text-3xl font-bold text-tie-navy mb-1">{stat.value}</p>
                    <p className="text-xs md:text-sm text-tie-text-muted">{stat.label}</p>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <WingPrograms
        title="Programmes in the Innovation Wing"
        programs={wingData.items}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      <WingPathwayNav />
    </main>
  );
}